/**
 * TemplateTable Component
 * Table view for templates
 */

import { memo } from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { TemplateTableRowMemo } from './TemplateTableRow';
import type { ITemplateTableProps } from '@/@types/messageTemplates';

function TemplateTable({ templates, isOwner, onEdit, onDelete, onCopy }: ITemplateTableProps) {
  if (templates.length === 0) {
    return null;
  }

  return (
    <div className="border border-border rounded-lg overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="bg-muted/50 hover:bg-muted/50">
            <TableHead className="w-[300px]">Template</TableHead>
            <TableHead className="w-[120px]">Category</TableHead>
            <TableHead className="w-[150px]">Channels</TableHead>
            <TableHead className="w-[80px]">Used</TableHead>
            <TableHead className="w-[120px]">Updated</TableHead>
            <TableHead className="w-[60px]"></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {templates.map(template => (
            <TemplateTableRowMemo
              key={template._id}
              template={template}
              isOwner={isOwner}
              onEdit={() => onEdit(template)}
              onDelete={() => onDelete(template._id)}
              onCopy={() => onCopy(template._id)}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export const TemplateTableMemo = memo(TemplateTable);
